export const VIEW_STATE = {
  MARKET: 'MARKET',
  ACCOUNT: 'ACCOUNT'
};

export const LOGIN_ERROR_CODES = {
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  ACCESS_DENIED: 'ACCESS_DENIED',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  INVALID_GRANT: 'INVALID_GRANT',
  SSO_ERROR: 'SSO_ERROR',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
};

export const USER_ERROR_CODES = {
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  ACCESS_DENIED: 'ACCESS_DENIED'
};

export const STEPS = {
  CATEGORIES: 'CATEGORIES',
  PRODUCTS: 'PRODUCTS',
  APPLICATION: 'APPLICATION',
  SHOPPING_CART: 'SHOPPING_CART'
};

export const PAYMENT_STATUS = {
  PAYMENT_WAIT_PROCESSING: 'PAYMENT_WAIT_PROCESSING',
  PAYMENT_IN_PROCESSING: 'PAYMENT_IN_PROCESSING',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_FAIL: 'PAYMENT_FAIL',
};

export const RECEIPT_STATUS = {
  RECEIPT_WAIT_PROCESSING: 'RECEIPT_WAIT_PROCESSING',
  RECEIPT_IN_PROCESSING: 'RECEIPT_IN_PROCESSING',
  RECEIPT_SUCCESS: 'RECEIPT_SUCCESS',
  RECEIPT_FAIL: 'RECEIPT_FAIL',
};

export const ERROR_TYPES = {
  ACCESS_DENIED: 'ACCESS_DENIED',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  AUTH_TOKEN_ERROR: 'AUTH_TOKEN_ERROR',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
};

export const PRODUCT_TYPES = {
  PIN_PRODUCTS: 'PIN_PRODUCTS',
  PHONERELOAD_US: 'PHONERELOAD_US',
  PHONERELOAD_INTERNATIONAL: 'PHONERELOAD_INTERNATIONAL',
  GIFT_CARDS: 'GIFT_CARDS',
  MONEY_TRANSFER: 'MONEY_TRANSFER',
  BILLPAYMENT: 'BILLPAYMENT',
  CARD_RELOAD: 'CARD_RELOAD',
  CHECK_CASHING: 'CHECK_CASHING'
};

export const REPORT_MODES = {
  SUMMARY: 'SUMMARY',
  DETAILED: 'DETAILED'
};

export const REPORT_TYPES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  CUSTOM: 'CUSTOM'
};

export const ACCOUNT_TABS = {
  TRANSACTIONS: 'TRANSACTIONS',
  REPORTS: 'REPORTS',
  CLERKS: 'CLERKS MANAGEMENT'
};

export const SCANNER_COMMANDS = {
  CHECK_CONNECTED: 'CHECK_CONNECTED',
  GET_DEVICES: 'GET_DEVICES',
  DO_CONNECT: 'DO_CONNECT',
  DO_SCAN: 'DO_SCAN',
  DO_DISCONNECT: 'DO_DISCONNECT'
};

export const SCANNER_RESPONSE_CODES = {
  RESP_ST_UNKNOWN : "RESP_ST_UNKNOWN",
  RESP_ST_OK : "RESP_ST_OK",
  RESP_ST_FAIL : "RESP_ST_FAIL",
  RESP_ST_NOT_CONNECTED : "RESP_ST_NOT_CONNECTED",
  RESP_ST_TIMEOUT : "RESP_ST_TIMEOUT",
  RESP_ST_NO_DEVICES : "RESP_ST_NO_DEVICES",
  RESP_ST_INVALID_ARG : "RESP_ST_INVALID_ARG"
};

export const SCANNER_STATES = {
  ST_NOT_CONNECTED: 0,
  ST_CHECKING_CONNECTION: 1,
  ST_GET_DEV_LIST: 2,
  ST_CONNECTING: 3,
  ST_CONNECTED: 4
};

export const USER_ROLES = {
  STORE_OWNER: 'store_owner',
  STORE_CLERK: 'store_clerk'
};

export const SCANNER_DEFAULT_VALUES = {
  DEVICE_NAME: 'ImageSafe.ImageSafe001',
  SCAN_TYPE: 'check', /* check, card */
  SCAN_TIMEOUT: 10000
};

export const CASH_A_CHECK_TRANSACTION_STATUSES = {
  BAD_IMAGES: 'bad_image',
  NOT_PARSED: 'not_parsed',
  BAD_MAKER: 'bad_maker',
  NOT_RECOGNIZED: 'not_recognized',
  INTERNAL: 'internal',
  CANCELED: 'canceled',
  APPROVED: 'approved',
  REVIEW: 'review'
};


// WEBPACK FOOTER //
// ./src/constants.js